import React from "react";
import "./button.scss";

interface PropsButton {
  children: JSX.Element;
  background: string;
  textColor: string;
  borderColor?: string;
  height?: number | string;
  width?: number | string;
  onClick?: any;
  padding?: string;
  isDisabled?: boolean;
  marginTop?: string;
  marginRight?: string;
  className?: any;
  marginLeft?: any;
  display?: any;
  minWidth?: string;
}

function Button(props: PropsButton) {
  return (
    <div className={props.className}>
      <button
        onClick={props.onClick}
        className={"machine-button"}
        style={{
          background: props.background,
          color: props.textColor,
          width: props.width,
          padding: props.padding,
          height: props.height,
          marginTop: props.marginTop,
          borderColor: props.borderColor,
          marginRight: props.marginRight,
          marginLeft: props.marginLeft,
          display: props.display,
          minWidth: props.minWidth,
          opacity: props.isDisabled ? 0.3 : 1,
        }}
        disabled={props.isDisabled}
      >
        {props.children}
      </button>
    </div>
  );
}

export default Button;
